import { getConditionalObject } from 'utils/data';

import { AutocompleteSize } from './AutocompleteCDS.constants';

const getAutocompleteHeight = size => (size === AutocompleteSize.SMALL ? '30px' : '38px');

export const getAutocompleteStyles = ({ multiple, isOneRow, size }) => {
  const autocompleteHeight = getAutocompleteHeight(size);

  return {
    width: '100%',

    '& .MuiFormControl-root': {
      width: '100%',
      margin: 0,
    },

    '& .MuiAutocomplete-clearIndicator': {
      color: ({ palette }) => palette.text.secondary,
    },

    '& .MuiInputBase-root': {
      padding: `0 ${autocompleteHeight} 0 0 !important`,
      ...getConditionalObject(!multiple, {
        '&:not(.MuiInputBase-multiline)': {
          height: autocompleteHeight,
        },
      }),
      ...getConditionalObject(multiple, {
        height: 'auto',
        minHeight: autocompleteHeight,
        '& input': {
          height: autocompleteHeight,
        },
      }),
      ...getConditionalObject(isOneRow, {
        flexWrap: 'nowrap',
      }),

      '&:has(.MuiChip-root)': {
        '& input': {
          padding: '9px 5px !important',
          height: autocompleteHeight,
        },
      },
    },

    '& .autocomplete-option-wrapper': {
      fontSize: '1.4rem',
    },
  };
};

export const optionStyles = {
  justifyContent: 'space-between !important',
  padding: '8px !important',
  borderRadius: ({ shape }) => shape.radius.l,
  cursor: 'pointer',
  color: ({ palette }) => palette.text.dark,

  '&[aria-selected="true"]': {
    color: ({ palette }) => palette.primary.main,
    backgroundColor: 'unset !important',
  },

  '&:hover, &.Mui-focused': {
    backgroundColor: ({ palette }) => `${palette.background.disabled} !important`,
  },
};

export const indicatorStyles = {
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

export const popperStyles = {
  '.MuiPaper-root': {
    borderRadius: ({ shape }) => shape.radius.l,
    marginTop: '8px',
  },
};

export const listboxStyles = {
  padding: '8px',
};

export const tagStyles = {
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.secondary,
  padding: '0 8px',

  '.MuiChip-label': {
    padding: '0 8px 0 0',
    fontSize: '14px',
  },
};

export const oneRowTagsStyles = {
  height: '40px',
  display: 'flex',
  scrollbarWidth: 'none',
  overflowX: 'auto',
};
